import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeading = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.25 4C6.66421 4 7 4.33579 7 4.75V11H17V4.75C17 4.33579 17.3358 4 17.75 4C18.1642 4 18.5 4.33579 18.5 4.75V19.25C18.5 19.6642 18.1642 20 17.75 20C17.3358 20 17 19.6642 17 19.25V12.5H7V19.25C7 19.6642 6.66421 20 6.25 20C5.83579 20 5.5 19.6642 5.5 19.25V4.75C5.5 4.33579 5.83579 4 6.25 4Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgHeading;
